export default {
    inserted(el, binding) {
        if (binding.value !== false) { // 默认允许聚焦，除非显式设为 false
            const input = el.querySelector('input')
            if (input) input.focus()
        }
    }
}